/**
 * 补零并转为字符串
 * @param { Number } num 数字
 * @return { String } 补零后的数字
 */
export default num => (num < 10 ? '0' : '') + num
